import React, { useMemo } from 'react';

import { Action, Actions } from '@gogame/components';
import { useGridApiContext } from '@gogame/data-grid';

import { useUpdatePermissions } from '../../data';
import PermissionsForm from '../PermissionsForm';
import { normalizeSubmittedValues } from '../UserForm';

const SelectedRowsToolbarActions = ({ selectedValues, openChildComponent }) => {
  const [updatePermissions] = useUpdatePermissions();
  const {
    current: { getRow },
  } = useGridApiContext();

  const selectedRows = useMemo(() => {
    if (!getRow) {
      return selectedValues.map((id) => ({ id }));
    }

    return selectedValues.map((id) => {
      const { name } = getRow(id);

      return {
        id,
        name,
      };
    });
  }, [selectedValues, getRow]);

  const handleAddPermissions = () => {
    openChildComponent(PermissionsForm, {
      initialValues: { users: selectedRows },
      title: 'Add Permissions',
      onSubmit: ({ users, ...values }) => {
        updatePermissions(
          normalizeSubmittedValues({
            ...values,
            userIds: users.map(({ id }) => id),
            operationType: 'add',
          })
        );
      },
    });
  };

  const handleDeletePermissions = () => {
    openChildComponent(PermissionsForm, {
      initialValues: { users: selectedRows },
      title: 'Delete Permissions',
      selectedLabel: () => 'To remove',
      onSubmit: ({ users, ...values }) => {
        updatePermissions(
          normalizeSubmittedValues({
            ...values,
            userIds: users.map(({ id }) => id),
            operationType: 'remove',
          })
        );
      },
    });
  };

  return (
    <Actions limit={3}>
      <Action button label={'Add permissions'} onClick={handleAddPermissions} />
      <Action
        button
        label={'Delete permissions'}
        onClick={handleDeletePermissions}
      />
    </Actions>
  );
};

export default SelectedRowsToolbarActions;
